export const sendPublicInfo = async (formData) => {
  const data = new FormData();
  for (const key in formData) {
    if (Object.prototype.hasOwnProperty.call(formData, key)) {
      data.append(key, formData[key]);
    }
  }
  const response = await fetch('api/send_publicInfo.php', {
    method: 'POST',
    body: data,
  });
  const result = await response.json();
  return { status: response.status, result };
};
